import {
  INIT_AUTH_CALL,
  CONFIRM_AUTH_CALL,
  REJECT_AUTH_CALL,
  SENDING_CONFIRM,
  AUTH_FAILED,
  CLOSE_AUTH_CALL,
} from './AuthConfirmationPrompt-Actions';

const initialState = {
  display: false,
  decided: false,
  authorized: false,
  isSending: false,
  error: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_AUTH_CALL:
      return {
        ...state,
        decided: false,
        display: action.payload,
        error: false,
      };
    case CONFIRM_AUTH_CALL:
      return {
        ...state,
        decided: true,
        authorized: true,
        error: false,
        isSending: false,
      };
    case REJECT_AUTH_CALL:
      return {
        ...state,
        decided: true,
        authorized: false,
        error: false,
        isSending: false,
      };
    case SENDING_CONFIRM:
      return {
        ...state,
        decided: true,
        error: false,
        isSending: true,
      };
    case AUTH_FAILED:
      return {
        ...state,
        decided: true,
        error: true,
        isSending: false,
      };
    case CLOSE_AUTH_CALL:
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
